import React, { useEffect, useRef, useState } from "react";

const SizeVariantSelect = ({
  id,
  variants = [],
  value = "",
  onChange,
  required = false,
  style,
  capitalize = (str) => str || "",
}) => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  const selected = variants.find((v) => v.title === value);

  useEffect(() => {
    const handleOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    if (open) {
      document.addEventListener("mousedown", handleOutside);
      document.addEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open]);

  const handleSelect = (title) => {
    onChange?.(title);
    setOpen(false);
  };

  return (
    <div
      className={`size-variant-select ${open ? "open" : ""}`}
      ref={rootRef}
      style={style}
    >
      {/* Keeps native required validation on form submit */}
      <select
        id={id}
        required={required}
        value={value}
        onChange={() => {}}
        tabIndex={-1}
        aria-hidden="true"
        className="size-variant-select-native"
      >
        <option value="">Please select a size</option>
        {variants.map((variant) => (
          <option key={variant.sku || variant.title} value={variant.title}>
            {variant.title}
          </option>
        ))}
      </select>

      <button
        type="button"
        className={`size-variant-select-trigger redemption-form-select ${
          value ? "has-value" : ""
        }`}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        {selected ? (
          <span className="size-variant-option-text">
            <span className="size-variant-option-title">
              {capitalize(selected.title)}
            </span>
            {selected.sku ? (
              <span className="size-variant-option-sku">{selected.sku}</span>
            ) : null}
          </span>
        ) : (
          <span className="size-variant-placeholder">Please select a size</span>
        )}
      </button>

      {open && (
        <ul className="size-variant-select-menu" role="listbox">
          {variants.map((variant) => {
            const isActive = variant.title === value;
            return (
              <li key={variant.sku || variant.title} role="option">
                <button
                  type="button"
                  className={`size-variant-select-option ${
                    isActive ? "active" : ""
                  }`}
                  onClick={() => handleSelect(variant.title)}
                >
                  <span className="size-variant-option-title">
                    {variant.title ? capitalize(variant.title) : ""}
                  </span>
                  {variant.sku ? (
                    <span className="size-variant-option-sku">
                      {variant.sku}
                    </span>
                  ) : null}
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SizeVariantSelect;
